import { render, staticRenderFns } from "./App.vue?vue&type=template&id=788f90f3"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/bootstrap-grid.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "@/assets/css/fonts.css?vue&type=style&index=1&prod&lang=css&external"
import style2 from "@/assets/css/globel.css?vue&type=style&index=2&prod&lang=css&external"
import style3 from "./App.vue?vue&type=style&index=3&id=788f90f3&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports